import PropTypes from 'prop-types';
import { useCallback, useRef } from 'react';
import { DialogContext } from './dialog-context';
import ConfirmDialog from '../ConfirmDialog';

export const DialogProvider = ({ children }) => {
  const dialogRef = useRef();

  const openDialog = useCallback(
    ({ title, description }) => dialogRef.current.open({ title, description }),
    []
  );

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <DialogContext.Provider value={{ openDialog }}>
      {children}
      <ConfirmDialog ref={dialogRef} />
    </DialogContext.Provider>
  );
};

DialogProvider.propTypes = {
  children: PropTypes.node,
};
